import { useWindowSize } from 'CustomHooks/useWindowSize';
import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import RMSvgIcon, { RMSvgIconProps } from '../RMSvgIcon';

import './Styles.scss';
import { RMDropDownSubMenuItem } from './RMDropDownSubmenuItem';
// import { title } from 'process';

export interface IDropDownList {
  Icon?: React.ReactNode;
  label?: string;
  onClick?: (e) => void;
  isDisabled?: boolean;
  iconProps?: RMSvgIconProps;
  titleTip?: string;
  itemClass?: string;
  renderItemContentRaw?: React.ReactNode;
  addSeparator?: boolean;
  subMenu?: IDropDownList[];
}

interface RMDropDownListProps {
  showDropDownList: boolean;
  setShowDropDownList: any;
  showCheckMarkOnSelected?: boolean;
  dropDownList?: IDropDownList[];
  parentContainerRef: any;
}
let divKey = 0;

const increamentDivkey = () => {
  divKey++;
};
function RMDropDownList(props: RMDropDownListProps) {
  const {
    showDropDownList,
    dropDownList,
    setShowDropDownList,
    parentContainerRef,
    showCheckMarkOnSelected = false,
  } = props;
  const [selectedRow, setSelectedRow] = useState<number>(-1);
  const dropDownMenuRef = useRef<HTMLInputElement>();
  const size = useWindowSize();

  useEffect(() => {
    increamentDivkey();
  }, [size]);

  useLayoutEffect(() => {
    if (!showDropDownList || !dropDownMenuRef.current || !parentContainerRef?.current) {
      return;
    }

    const buttonRect = parentContainerRef.current.getBoundingClientRect();
    const dropDownWidth = dropDownMenuRef.current.offsetWidth;
    const { innerWidth: width } = window;

    let newPositionX = buttonRect.left;

    if (width < newPositionX + dropDownWidth) {
      newPositionX = buttonRect.right - dropDownWidth;
    }

    newPositionX = Math.max(0, newPositionX);

    dropDownMenuRef.current.style.left = `${newPositionX}px`;
    dropDownMenuRef.current.style.top = `${buttonRect.bottom}px`;
  }, [showDropDownList, size, parentContainerRef]);

  return (
    <div
      id={`index-dropdownlist-${divKey}-wrapper`}
      data-testid={`index-dropdownlist-${divKey}-wrapper`}
      style={{ display: showDropDownList ? 'block' : 'none' }}
    >
      <div
        id={`index-dropdownlist-${divKey}-menu`}
        data-testid={`index-dropdownlist-${divKey}-menu`}
        ref={dropDownMenuRef}
        key={divKey}
        className="rm-drop-down-list"
      >
        {dropDownList.map((item, index) => {
          if (item.subMenu?.length) {
            return (
              <span
                key={`sub-parent-${index}`}
                {...(item?.titleTip && { title: item.titleTip })}
              >
                <RMDropDownSubMenuItem
                  item={item}
                  setShowDropDownList={setShowDropDownList}
                />
              </span>
            );
          }
          return item.renderItemContentRaw ? (
            item.renderItemContentRaw
          ) : (
            <span
              id={`index-dropdownlist-${item.label}-item-span-${index}`}
              data-testid={`index-dropdownlist-${item.label}-item-span-${index}`}
              {...(item?.titleTip && { title: item.titleTip })}
            >
              <div
                id={`index-dropdownlist-${item.label}-item-${index}`}
                data-testid={`index-dropdownlist-${item.label}-item-${index}`}
                key={`drop-down-list-item-${item.label}-${index}`}
                className={`${
                  item.isDisabled
                    ? 'rm-drop-down-list-row-disabled'
                    : item.onClick
                    ? 'rm-drop-down-list-row rm-drop-down-list-row-hover'
                    : 'rm-drop-down-list-row'
                } ${item.itemClass} ${
                  item.addSeparator && 'border-solid border-0 border-b border-b-[#E0E0E0]'
                }`}
                onClick={
                  item.onClick
                    ? (e) => {
                        item.onClick(e);
                        setSelectedRow(index);
                        setShowDropDownList(false);
                      }
                    : undefined
                }
              >
                {item.iconProps && (
                  <div
                    id={`index-dropdownlist-${item.label}-item-iconprops-${index}`}
                    data-testid={`index-dropdownlist-${item.label}-item-iconprops-${index}`}
                    className="rm-drop-down-list-row-icon"
                  >
                    <RMSvgIcon {...item.iconProps} />
                  </div>
                )}
                {item.Icon && (
                  <div
                    id={`index-dropdownlist-${item.label}-item-icon-${index}`}
                    data-testid={`index-dropdownlist-${item.label}-item-icon-${index}`}
                    className="rm-drop-down-list-row-icon"
                  >
                    {item.Icon}
                  </div>
                )}
                {item.label && (
                  <div
                    id={`index-dropdownlist-${item.label}-item-label-${index}`}
                    data-testid={`index-dropdownlist-${item.label}-item-label-${index}`}
                    className="rm-drop-down-list-row-text"
                  >
                    {item.label}
                  </div>
                )}
                {showCheckMarkOnSelected && selectedRow === index && (
                  <RMSvgIcon
                    id={`index-dropdownlist-${item.label}-item-checkmark-svg-icon`}
                    data-testid={`index-dropdownlist-${item.label}-item-checkmark-svg-icon`}
                    style={{ position: 'absolute', right: '12%' }}
                    name="checkMark"
                    fill="#313131"
                  />
                )}
              </div>
            </span>
          );
        })}
      </div>
    </div>
  );
}

export default RMDropDownList;
